
import { computed, defineComponent, ref, onMounted, watch } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { SMTasks, SMUser } from "@/store";

export default defineComponent({
  name: "RTWCStep1",
  components: {
    ActionButtons: () => import("@/components/ActionContainer/ActionButtonsV2.vue"),
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
  },
  emits: ["proceed"],
  setup(props, { emit }) {
    const loading = ref(false);

    const isConfirmed = ref(false);

    const isError = ref(false);

    const errorMessage = ref(
      "We’re experiencing a technical issue on our side. Please close this task and try again. If the problem persists, contact our support team for assistance."
    );

    const isMaskCompleted = ref(true);

    function completeMask(isCompleted: boolean) {
      isMaskCompleted.value = isCompleted;
    }

    const isDisabled = computed(() => {
      if (isError.value) return true;

      if (SMUser.isEmployee) return true;

      return !isConfirmed.value || !isMaskCompleted.value || loading.value;
    });

    const payload = ref({
      date_of_birth: "17/04/1997",
      share_code: "",
      company_name: SMUser.user?.company?.CompanyProfile?.name || "",
      task_id: SMTasks.taskTemplate.id,
    });

    onMounted(async () => {
      if (!SMTasks.taskTemplate.target_user_id) return console.log("No target_user_id");

      try {
        loading.value = true;

        const { data } = await axios.get(
          API_ROUTES.COMPLIANCE_RTWC_DATA(SMTasks.taskTemplate.target_user_id)
        );

        if (!data) return;

        payload.value.date_of_birth = data.date_of_birth || "";
        payload.value.share_code = data.share_code || "";
      } finally {
        loading.value = false;
      }
    });

    async function runBot() {
      try {
        loading.value = true;

        const { data } = await axios.post(API_ROUTES.COMPLIANCE_RTWC, payload.value);

        if (!data) return;

        emit("proceed", data);
      } catch {
        isError.value = true;
      } finally {
        loading.value = false;
      }
    }

    watch(
      () => payload.value,
      () => {
        isError.value = false;
      },
      { deep: true, immediate: true }
    );

    return {
      loading,
      isConfirmed,
      isDisabled,
      payload,
      runBot,
      isError,
      errorMessage,
      completeMask,
    };
  },
});
